/**
 * CA 在线申请 · 会话状态
 *
 * state 只放 customerCode（客户编码），并单独持久化到 localStorage：
 * 客户门户可能以 {code}.平台域名 访问，也可能在生产环境后拼接 ?code=xx 访问。
 * 后者的编码只存在于入口 URL 上，站内跳转（如「我的订单」）会丢掉 query，
 * 刷新后如果只靠内存 store 就解析不出客户，会被守卫打到 ca-error。
 * 因此写入时落一份本地缓存，模块初始化时读回，刷新 / 站内跳转 / 退出登录后都能恢复。
 * 注意：不要恢复整包 vuex-persistedstate，也不能把 pageData（品牌、业务类型等接口配置）
 * 放进来 —— 它会过期、客户可能切换，每次进入 CA 页面时由 CaLayout 重新拉取。
 */

export const CUSTOMER_CODE_STORAGE_KEY = 'ZCJF_CA_CUSTOMER_CODE'

/** 读取本地缓存的客户编码；存储被禁用（隐私模式等）时返回 ''，不阻断页面 */
export function readStoredCustomerCode() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return ''
    return window.localStorage.getItem(CUSTOMER_CODE_STORAGE_KEY) || ''
  } catch (err) {
    return ''
  }
}

/** 写入 / 清除本地缓存的客户编码；存储不可用时静默降级为仅本次会话有效 */
function persistCustomerCode(code) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return
    if (code) window.localStorage.setItem(CUSTOMER_CODE_STORAGE_KEY, code)
    else window.localStorage.removeItem(CUSTOMER_CODE_STORAGE_KEY)
  } catch (err) {
    // 隐私模式 / 存储被禁用：内存 store 仍可在本次会话内正常工作
  }
}

const ca = {
  namespaced: true,
  state: {
    // 当前客户编码（如 'zcjb'），由路由守卫在解析后写入；刷新时从本地缓存恢复
    customerCode: readStoredCustomerCode(),
  },
  mutations: {
    setCustomerCode(state, code) {
      state.customerCode = code || ''
      persistCustomerCode(state.customerCode)
    },
  },
}

export default ca
